import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import {
  startCase, delay, map, each,
} from 'lodash';
import { fetchNews, requestDeleteNews, resetUpdateNews } from '../../AdminActions';
import { getNews, getNewsLoading, getNewsLoaded,
  getNewsHasErrors, getNewsErrors } from '../../AdminReducer';
import ProgressBar from '../../../../components/progress-bar';
import SearchField from '../../../../components/search-field';
import { getViewableDimensions } from '../../../App/AppReducer';
import TitleRenderer from './TitleRenderer';
import VisibleRenderer from './VisibleRenderer';
import DateRenderer from '../../../../components/table-cells/DateRenderer';
import TypeRenderer from './TypeRenderer';
import ActionCellRenderer from './ActionCellRenderer';

class NewsIndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: {},
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.dateColumnCellRendererSelector = this.dateColumnCellRendererSelector.bind(this);
    this.nameColumnCellRendererSelector = this.nameColumnCellRendererSelector.bind(this);
    this.actionColumnCellRendererSelector = this.actionColumnCellRendererSelector.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchNews())
      .then(() => {
        this.props.dispatch(resetUpdateNews());
      });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { viewableDimensions } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = viewableDimensions.width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        this.gridApi.hideOverlay();
      }, 500);
    }
  }

  getItemClass(item) {
    return item.$isUpdated ? 'animated flash' : '';
  }

  
  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  handleDelete(item) {
    const { deleting } = this.state;
    this.setState({ deleting: { ...deleting, [item._id]: true } });
    this.props.dispatch(requestDeleteNews(item._id))
      .then(
        () => {
          this.setState({ deleting: { ...deleting, [item._id]: false } });
        },
        () => {
          this.setState({ deleting: { ...deleting, [item._id]: false } });
        },
      );
  }

  dateColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { value } = params;
    if (value) {
      return {
        params: {
          format: 'short',
        },
        component: DateRenderer,
      };
    }
    return {};
  }

  nameColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { value } = params;

    if (value) {
      return null;
    }
    return {};
  }

  actionColumnCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    const { deleting } = this.state;
    const { value } = params;

    return {
      params: {
        deleting: deleting[value],
        requestDelete: this.handleDelete,
      },
      component: ActionCellRenderer,
    };
  }

  renderNewsTags(news) {
    const { types } = news;
    if (types && types.length) {
      return (
        <div>
          {types.map(t => (
            <span key={t}><span className="label label-primary">{startCase(t)}</span> </span>
          ))}
        </div>
      );
    }
    return null;
  }

  renderResults() {
    const { news, viewableDimensions } = this.props;
    if (news.length === 0) {
      return (
        <div>
          <div className="alert alert-warning">No Announcements found.</div>
          <p><Link to="/admin/news/add"><Fa name="plus" /> Add new Announcement</Link></p>
        </div>
      );
    }

    const columnDefs = [
      {
        headerName: '',
        field: 'is_visible',
        pinned: 'left',
        colId: 'VISIBLE',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        resizable: false,
        sortable: false,
        suppressSizeToFit: true,
        width: 40,
        maxWidth: 40,
        cellRenderer: VisibleRenderer,
      },
      {
        headerName: 'Title',
        field: 'title',
        pinned: 'left',
        colId: 'TITLE',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 300,
        cellRenderer: TitleRenderer,
      },
      {
        headerName: 'Types',
        field: 'types',
        colId: 'TYPES',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        sortable: false,
        width: 250,
        cellRenderer: TypeRenderer,
      },
      {
        headerName: 'Announcement Date',
        field: 'announcement_date',
        colId: 'ANN_DATE',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 200,
        cellRendererSelector: this.dateColumnCellRendererSelector,
      },
      {
        headerName: 'Created',
        field: 'creator.display_name',
        colId: 'CREATOR',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 150,
        cellRendererSelector: this.nameColumnCellRendererSelector,
      },
      {
        headerName: 'Last Editor',
        field: 'editor.display_name',
        colId: 'EDITOR',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 150,
        cellRendererSelector: this.nameColumnCellRendererSelector,
      },
      {
        headerName: 'ACTIONS',
        field: '_id',
        pinned: 'right',
        colId: 'ACTION',
        suppressMenu: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        resizable: false,
        sortable: false,
        suppressSizeToFit: true,
        width: 120,
        cellRendererSelector: this.actionColumnCellRendererSelector,
      },
    ];
    
    const { height } = viewableDimensions;

    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField collapsible={false} onSearch={this.handleSearch} />
          </form>
          <form className="navbar-form navbar-right">
            <Link to="/admin/news/add" className="btn btn-primary">
              <Fa name="plus" /> Add New
            </Link>&nbsp;&nbsp;
          </form>
        </nav>
        <div className="ag-theme-alpine" style={{ width: '100%', height }}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            animateRows
            suppressColumnVirtualisation
            columnDefs={columnDefs}
            getRowId={(params) => params.data._id}
            onGridReady={this.onGridReady}
            onFirstDataRendered={this.onFirstDataRendered}
            rowData={news}
          />
        </div>
      </div>
    );
  }


  render() {
    const { loading, hasErrors } = this.props;

    return (
      <div>
        <Helmet title="Manage Announcements" />
        <p />
        <div className="container">
          {loading && <ProgressBar />}
          {!loading && !hasErrors && this.renderResults()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getNewsLoading(state),
    loaded: getNewsLoaded(state),
    hasErrors: getNewsHasErrors(state),
    errors: getNewsErrors(state),
    news: getNews(state),
    viewableDimensions: getViewableDimensions(state),
  };
}

NewsIndexPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  hasErrors: PropTypes.bool,
  errors: PropTypes.shape({}),
  news: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
  })).isRequired,
  viewableDimensions: PropTypes.shape({}).isRequired,
};

NewsIndexPage.defaultProps = {
  loading: false,
  loaded: false,
  hasErrors: false,
  errors: null,
};

NewsIndexPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(NewsIndexPage);
